<template>
  <img width="16" height="16" src="@/assets/icons/error.png">
</template>

<script>
export default {
  name: "IconError"
}
</script>
